import { toast } from 'react-toastify';
import actions from '../../../../../constants/actionTypes';
import request from '../../../../../utils/request';
import { isEmpty, isSuccess } from '../../../../../utils/utils';
import { startAppLoading, stopAppLoading } from '../../../../../layout/actions';
import { trans } from '../../../../../localization';
import { closeDialogGeneric } from '../../../../../redux/genericAction';
import { EnumPage, EnumTransferOrderStep } from '../../../../../constants/enum';
import { getListManagerOrder } from '../../actions';

const TIME_OF_DISPLAYING_SUCCESS_CHANGE_BRANCH_MESSAGE = 5000;

export function startTransferringOrder(transferredOrder) {
  return {
    type: actions.START_TRANSFERRING_ORDER,
    response: transferredOrder,
  };
}

export function stopTransferringOrder() {
  return {
    type: actions.STOP_TRANSFERRING_ORDER,
  };
}

export function selectTransferredBranch(selectedBranch) {
  return {
    type: actions.TRANSFERRED_BRANCH_SELECTED,
    response: selectedBranch,
  };
}

export function goToVerifyingStep() {
  return {
    type: actions.GO_TO_VERIFYING_STEP,
  };
}

export function getRestaurantsInBrand(restaurantId) {
  return async (dispatch) => {
    dispatch(startAppLoading());

    const response = await request.postMerchant(
      '/api/restaurant/get_restaurants_in_brand',
      { restaurant_id: restaurantId },
    );

    dispatch(stopAppLoading());

    if (isSuccess(response)) {
      return response.reply.restaurants;
    }

    throw response.result;
  }
}

export function changeRestaurantOfOrder(orderCode, targetRestaurantId, confirmCode, restaurantName) {
  return async (dispatch, getState) => {
    if (!isEmpty(confirmCode)) {
      dispatch(startAppLoading());
    }

    const response = await request.postMerchant(
      '/api/order/change_restaurant',
      {
        order_code: orderCode,
        target_restaurant_id: targetRestaurantId,
        ...(!isEmpty(confirmCode) && { confirm_code: confirmCode}),
      },
    );

    dispatch(stopAppLoading());

    if (!isEmpty(confirmCode)) {
      if (isSuccess(response)) {
        if (isEmpty(response.reply)) {
          toast.success(
            trans('transferring_order_successfully', [restaurantName]),
            { autoClose: TIME_OF_DISPLAYING_SUCCESS_CHANGE_BRANCH_MESSAGE },
          );

          // Close transferring dialog
          dispatch({ type: actions.STOP_TRANSFERRING_ORDER });

          // Close order detail
          dispatch(closeDialogGeneric(EnumPage.ORDER_MANAGEMENT.id));

          // Refresh list order
          dispatch(getListManagerOrder())
        } else {
          // This case means there is something changed when order is transferred
          // User need to check again
          toast.info(trans('new_branch_data_changed'));

          dispatch({
            type: actions.ATTEMPT_CHANGE_RESTAURANT_SUCCESSFULLY,
            response: { ...response.reply }
          })
        }
      } else {
        dispatch({ type: actions.CHANGE_RESTAURANT_FAILED })
      }
    } else if (getState().transferOrder.stepId === EnumTransferOrderStep.VERIFY_BRANCH.id) {
      // Check whether user cancel transferring order or not
      // If not, do nothing
      if (isSuccess(response)) {
        dispatch({
          type: actions.ATTEMPT_CHANGE_RESTAURANT_SUCCESSFULLY,
          response: { ...response.reply }
        })
      } else {
        dispatch({
          type: actions.ATTEMPT_CHANGE_RESTAURANT_FAILED,
          response: response.result,
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/actions.js